import React from "react";

import { GET_IMAGE } from "../../../helpers/images";
import ChatAvatar from "../ChatAvatar";
import SoftBox from "../../SoftBox";
import SoftTypography from "../../SoftTypography";

const SearchedUserList = ({ image, name, userId, createChatTrigger }) => {
  return (
    <SoftBox
      display="flex"
      alignItems="center"
      sx={{
        "&:hover": {
          backgroundColor: "#EFF6FF",
          cursor: "pointer",
        },
        color: "#344767",
        padding: "0.5rem",
        borderRadius: "0.75rem",
      }}
      onClick={() => {
        createChatTrigger(userId);
      }}
    >
      <ChatAvatar name={name} image={image ? GET_IMAGE(image) : null} size={36} />
      <SoftBox ml={2} lineHeight={1}>
        <SoftTypography
          display="block"
          variant="h6"
          sx={{
            fontSize: "16px",
          }}
        >
          {name}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
};

export default SearchedUserList;
